import { render, staticRenderFns } from "./CompetitionAdminUnapproved.vue?vue&type=template&id=3b825f19&scoped=true&"
import script from "./CompetitionAdminUnapproved.vue?vue&type=script&lang=js&"
export * from "./CompetitionAdminUnapproved.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionAdminUnapproved.vue?vue&type=style&index=0&id=3b825f19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b825f19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VLazy,VRow,VSelect,VSimpleTable})
